// Auth Service API Client

import { BaseApiClient } from '../BaseApiClient';
import {
  RefreshTokenRequest,
  RefreshTokenResponse,
  TelegramAuthRequest,
  TelegramAuthResponse,
} from './types';

class AuthApiClient extends BaseApiClient {
  constructor() {
    super({ prefix: 'auth' });
  }

  /**
   * Authenticate user through Telegram Mini App
   */
  async authenticateWithTelegram(
    request: TelegramAuthRequest
  ): Promise<TelegramAuthResponse> {
    return this.makeRequest<TelegramAuthResponse>('/telegram', {
      method: 'POST',
      data: request,
    });
  }

  /**
   * Refresh access and refresh tokens
   */
  async refreshSession(
    request: RefreshTokenRequest
  ): Promise<RefreshTokenResponse> {
    return this.makeRequest<RefreshTokenResponse>('/refresh-session', {
      method: 'POST',
      data: request,
    });
  }
}

// Export singleton instance
export const authApi = new AuthApiClient();
export default authApi;
